module.exports = __webpack_public_path__ + "static/media/6_School of the animals_EN.27105055.txt";